import { render } from "./Actions.vue?vue&type=template&id=61c79831&scoped=true"
import script from "./Actions.vue?vue&type=script&lang=js"
export * from "./Actions.vue?vue&type=script&lang=js"

import "./Actions.vue?vue&type=style&index=0&id=61c79831&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61c79831"]])

export default __exports__